import * as React from 'react';
import { RssSite } from '../../types';

// RssSiteCmp was used with { ...result.site } spreading.
// result.site is a Site object.
// So usage is <RssSiteCmp id={...} siteTitle={...} />
// The component implementation uses props.siteTitle.

export default function RssSiteCmp(props: RssSite) {
  return (
    <React.Fragment>
      <h1>{props.siteTitle}</h1>
    </React.Fragment>
  );
}
